import '@hotwired/turbo-rails';
import '../controllers';

// Not `import Vue from 'vue'`: this root instance mounts on `#page` with no
// `render`/`template` option, so Vue compiles the template straight from the
// DOM at runtime. That needs the full build (with compiler); the plugin's
// default `vue` alias points at the runtime-only build used for SFCs.
import Vue from 'vue/dist/vue.esm.js';
import i18n from '../utils/i18n';
import icon from '../utils/icons';

import Datepicker from '../components/datepicker';
import InlineSvg from 'vue-inline-svg';
import InteractiveInput from '../components/interactive_input';
import MarketBasedOptions from '../components/market_based_options';
import MeterSelect from '../components/meter_select';
import Modal from '../components/modal';
import SelectFilter from '../components/select_filter';
import SelectFilterTransport from '../components/select_filter_transport';

Vue.prototype.$icon = icon;

document.addEventListener('turbo:load', () => {
  const app = new Vue({
    el: '#page',
    components: {
      // Async: chart.vue pulls in Highcharts + Highstock + several modules,
      // by far the biggest dependency here — loading it eagerly meant every
      // page shipped it even when it never renders a <chart>.
      Chart: () => import('../components/chart'),
      Datepicker,
      InlineSvg,
      InteractiveInput,
      MarketBasedOptions,
      MeterSelect,
      Modal,
      SelectFilter,
      SelectFilterTransport,
    },

    data: function () {
      return {
        i18n: i18n,
      };
    },
  });
});
